<template>
  <div class="answer">
    <p class="answer__text">
      <!-- <SmartInput v-model="answer.text" @change="onAnswerChange(answer)"/> -->
      <vue-editor
        style="max-height:350px; overflow-y: auto;"
        v-model="answer.text"
        @text-change="debounce(answer)"
        :editorToolbar="customToolbar"
      ></vue-editor>
    </p>
    <!--<div class="btn btn-light" @click="isHidden=false" v-show="isHidden">Подробнее</div>-->
    <!--<div class="answer__info"  v-if="!isHidden">-->
    <div class="answer__info">
      <div class="flex">
        <!-- <div class="answer__score flex-between">
          <span v-if="answer.score > 0">+</span>
          <SmartInput v-model="answer.score" @change="onAnswerChange(answer)"/>
        </div> -->
        <!-- <div class="answer__critical">
          <label class="checkbox-container">
            <input type="checkbox" v-model="answer.is_critical" @change="onAnswerChange(answer)">
            <span class="checkmark"></span>
          </label>
        </div> -->
        <!-- <div class="answer__points">
          <AnswerPoints :answer="answer" @answerChange="onAnswerChange"/>
        </div> -->
      </div>
      <div class="answer__next-question">
        <select @change="onNextQuestionChange(answer, $event)">
          <option value="-1" :selected="answer.success === true">Успешное завершение теста</option>
          <option value="-2" :selected="answer.success === false">Неуспешное завершение теста</option>
          <option :value="q.id"
                  v-for="q in testQuestions"
                  :key="q.id"
                  :selected="q.id == answer.next_question"
                  v-if="q.id != question.id">
            {{q.id}} <span v-html="parseText(q.text)"></span>
          </option>
        </select>
      </div>
      <div class="answer__footer">
        <div class="answer__critical">
          <label class="checkbox-container">
            <input type="checkbox" v-model="answer.is_critical" @change="onAnswerChange(answer)">
            <span class="checkmark"></span>
          </label>
        </div>
        <div class="answer__action">
          <div class="remove" @click="removeAnswer(answer.id)" title="Удалить вопрос">
            <font-awesome-icon icon="trash"/>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import AnswerPoints from '@/components/tests/AnswerPoints'
  import SmartInput from '@/components/SmartInput'
  import QuestionsService from '@/services/QuestionsService'
  import { VueEditor } from 'vue2-editor'

  function debounce (func, timeout = 500) {
    let timer
    return (...args) => {
      clearTimeout(timer)
      timer = setTimeout(() => { func.apply(this, args) }, timeout)
    }
  }

  const processChange = debounce((answer, func) => func(answer))

  export default {
    name: 'QuestionAnswer',
    props: ['answer', 'question', 'onUploadProgress'],
    components: {
      AnswerPoints,
      VueEditor,
      SmartInput
    },
    data () {
      return {
        isHidden: true,
        customToolbar: [
           [{ header: [false] }]
        ]
      }
    },
    computed: {
      testQuestions () {
        return this.$store.getters.test.test_questions
      },
      testId () {
        return this.$store.getters.test.id
      }
    },
    methods: {
      debounce (answer) {
        processChange(answer, this.onAnswerChange)
      },
      parseText (text) {
        return this.$options.filters.ellipsis(text, 50)
      },
      onAnswerChange (answer) {
        console.log('answer', answer)
        QuestionsService.patchAnswer(this.testId, this.question.id, answer, this.onUploadProgress).then(
          (response) => {
            let payload = {}
            payload.answer = answer
            payload.questionId = this.question.id
            this.$store.dispatch('setAnswer', payload)
            this.$parent.changeProgress(0)
          }
        )
      },
      onNextQuestionChange (answer, event) {
        let val = parseInt(event.target.value)
        if (val === -1) { // успешное завершение
          answer.success = true
          answer.next_question = null
        } else if (val === -2) { // неуспешное завершение
          answer.success = false
          answer.next_question = null
        } else {
          answer.success = null
          answer.next_question = val
        }
        this.onAnswerChange(answer)
      },
      removeAnswer (answerId) {
        QuestionsService.deleteAnswer(this.testId, this.question.id, answerId, this.onUploadProgress).then(
          (response) => {
            this.$store.dispatch('deleteAnswerFromQuestion', {answerId, questionId: this.question.id})
            this.$parent.changeProgress(0)
          }
        )
      }
    }
  }
</script>

<style scoped lang="scss">
  .answer {
    background-color: $very-light-blue;
    border-radius: 5px;
    margin-bottom: 10px;
    padding: 10px;
    display: flex;
    position: relative;
    &__action {
      position: absolute;
      right: 10px;
      bottom: 10px;
      margin-left: 10px;
      .remove, .edit {
        cursor: pointer;
        font-size: 16px;
        padding: 0;
        path {
          fill: #a6b5d1;
        }
        &:hover path {
          fill: $blue;
        }
      }
      .remove {
        padding: 15px;
        border-radius: 12px;
      }
    }

    &__text {
      padding-right: 15px;
      width: 60%;
      display: flex;
      align-items: center;
      margin: 0;
    }
    &__info {
      width: 40%;
    }
    &__score {
      width: 20px;
      font-weight: bold;
      color: $blue;
      font-size: 18px;
    }
    &__points {
      position: relative;

    }
    select {
      padding: 3px 5px;
      font-size: 14px;
      option {
        max-width: 100px;
        /*overflow: eli;*/
      }
    }
    &__next-question {
      // display: flex;
      // align-items: center;
      // margin-top: 3px;
      // span {
      //   font-size: 12px;
      // }
      // select {
      //   flex: 1;
      // }
      position: relative;
      display: flex;
      // width: 20em;
      height: 3em;
      border-radius: .25em;
      overflow: hidden;

      &::after {
        content: '\25BC';
        position: absolute;
        top: 0;
        right: 0;
        padding: 1em;
        background-color: #fff;
        transition: .25s all ease;
        pointer-events: none;
      }
      select {
        /* Reset Select */
        appearance: none;
        outline: 0;
        border: 0;
        box-shadow: none;
        /* Personalize */
        flex: 1;
        padding: 0 1em;
        font-size: 10px;
        border-radius: 10px;
        color: black;
        background-color: #fff;
        background-image: none;
        cursor: pointer;
      }
    }
    &__footer {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
    }
  }
  /* Customize the label (the container) */
  .checkbox-container {
    display: block;
    position: relative;
    /*padding-left: 35px;*/
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 18px;
    height: 18px;
    // margin: 0 24px;
    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      &:checked ~ .checkmark {
        background-color: #cf5555;
        &:after {
          display: block;
        }
      }
    }
    .checkmark {
      position: absolute;
      top: 0;
      left: 0;
      height: 10px;
      width: 50px;
      // border-radius: 50%;
      background-color: #34b747;
      &:after {
        content: "";
        position: absolute;
        display: none;
      }
    }
    &:hover input ~ .checkmark {
      /*background-color: #ccc;*/
    }
  }
  .flex {
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/tests/QuestionAnswer.vue